import e from "react";
import n from "gotrue-js";
var t = /(confirmation|invite|recovery|email_change)_token=([^&]+)/,
  r = /error=access_denied&error_description=403/,
  o = /access_token=/,
  i = /confirmation_token=/,
  u = {
    autoconfirm: !1,
    disable_signup: !1,
    external: {
      bitbucket: !1,
      email: !0,
      facebook: !1,
      github: !1,
      gitlab: !1,
      google: !1
    }
  },
  c = l(),
  a = c[1],
  s = c[0];
function f(n) {
  var t = n.url,
    r = n.children,
    o = n.onAuthChange,
    i = void 0 === o ? function () {} : o;
  if (!t || !/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(t)) throw new Error("invalid netlify instance URL: " + t + ". Please check the docs for proper usage or file an issue.");
  var u = d(t, i);
  return e.createElement(a, {
    value: u
  }, r);
}
function d(c, a, s) {
  void 0 === a && (a = function () {}), void 0 === s && (s = !0);
  var f = e.useMemo(function () {
      return new n({
        APIUrl: c + "/.netlify/identity",
        setCookie: !0
      });
    }, [c]),
    d = e.useState(f.currentUser() || void 0),
    l = d[0],
    h = d[1],
    v = function (e) {
      return h(e), a(e), e;
    };
  e.useEffect(function () {
    s && function (e, n, u) {
      void 0 === u && (u = !0);
      var c = (document.location.hash || "").replace(/^#\/?/, "");
      if (c) {
        c.match(t) && (document.location.hash = ""), c.match(r) && (document.location.hash = "");
        var a = {};
        c.split("&").forEach(function (e) {
          var n = e.split("=");
          a[n[0]] = n[1];
        }), c.match(o) && (document && a.access_token && (document.cookie = "nf_jwt=" + a.access_token), document.location.hash = "", e.createUser(a, u).then(n).catch(console.error)), c.match(i) && (document.location.hash = "", e.confirm(a.confirmation_token).then(n).catch(console.error));
      }
    }(f, v);
  }, []);
  var g = f.settings.bind(f),
    p = e.useState(u),
    m = p[0],
    w = p[1];
  e.useEffect(function () {
    g().then(function (e) {
      return w(e);
    });
  }, []);
  var k = function (e) {
      return function (n, t) {
        if (void 0 === t && (t = {}), !l || !l.token || !l.token.access_token) throw new Error("no user token found");
        var r = Object.assign({
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + l.token.access_token
          }
        }, {
          method: e
        }, t);
        return fetch(n, r).then(function (e) {
          return "application/json" === r.headers["Content-Type"] ? e.json() : e;
        });
      };
    },
    E = {
      get: k("GET"),
      post: k("POST"),
      put: k("PUT"),
      delete: k("DELETE")
    };
  return {
    user: l,
    setUser: h,
    isConfirmedUser: !(!l || !l.confirmed_at),
    isLoggedIn: !!l,
    signupUser: function (e, n, t) {
      return f.signup(e, n, t).then(v);
    },
    loginUser: function (e, n, t) {
      return void 0 === t && (t = !0), f.login(e, n, t).then(v);
    },
    logoutUser: function () {
      if (!l) throw new Error("No current user found - are you logged in?");
      return l.logout().then(function () {
        return v(void 0);
      });
    },
    requestPasswordRecovery: function (e) {
      return f.requestPasswordRecovery(e);
    },
    recoverAccount: function (e, n) {
      return f.recover(e, n);
    },
    updateUser: function (e) {
      if (null == l) throw new Error("No current user found - are you logged in?");
      return l.update(e).then(v);
    },
    getFreshJWT: function () {
      if (!l) throw new Error("No current user found - are you logged in?");
      return l.jwt();
    },
    authedFetch: E,
    _goTrueInstance: f,
    _url: c,
    loginProvider: function (e) {
      var n = f.loginExternalUrl(e);
      window.location.href = n;
    },
    acceptInviteExternalUrl: function (e, n) {
      return f.acceptInviteExternalUrl(e, n);
    },
    settings: m
  };
}
function l() {
  var n = e.createContext(void 0);
  return [function () {
    var t = e.useContext(n);
    if (!t) throw new Error("useCtx must be inside a Provider with a value");
    return t;
  }, n.Provider];
}
export { f as IdentityContextProvider, s as useIdentityContext, d as useNetlifyIdentity };